exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-bottom {\n  padding-left: 68px;\n}\n", ""]);

// exports
